import React from "react";
import {
  InputAnnouncement,
  InputConventionTitle,
  FileBackgroundImage,
  InputAbbrev,
  ToggleDarkMode,
  TogglePublicMondo,
  TogglePublicFunko,
  TogglePublicLoungefly,
  ProductTable,
  ButtonDeleteConvention,
} from "./components";
import "./index.scss";
import { useSelector } from "react-redux";
import { getSelfServiceCnameSelector } from "../../../../store/selfServiceSlice";

/**
 * @desc Convention form body.
 */
export const ConventionForm = () => {
  const cname = useSelector(getSelfServiceCnameSelector);
  const disabled = !cname;

  // COMPONENT ----------------------------------------------------------------

  return (
    <div className="convention-form" key={cname}>
      <FileBackgroundImage disabled={disabled} />
      <InputAnnouncement disabled={disabled} />
      <InputConventionTitle disabled={disabled} />
      <InputAbbrev disabled={disabled} />
      <ToggleDarkMode disabled={disabled} />
      <TogglePublicMondo disabled={disabled} />
      <TogglePublicFunko disabled={disabled} />
      <TogglePublicLoungefly disabled={disabled} />
      <ProductTable />
      <ButtonDeleteConvention />
    </div>
  );
};
